"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valsamoggia": {
    "678cc008": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "f94558c3": [{
      "hkey": "f847f122",
      "slug": "bersagliera",
      "name": "Bersagliera",
      "primary": true,
      "skipSearch": false
    }],
    "bersagliera": [{
      "hkey": "f847f122",
      "slug": "bersagliera",
      "name": "Bersagliera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "e75433a3": [{
      "hkey": "0d10fbf8",
      "slug": "bortolani",
      "name": "Bortolani",
      "primary": true,
      "skipSearch": false
    }],
    "bortolani": [{
      "hkey": "0d10fbf8",
      "slug": "bortolani",
      "name": "Bortolani",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "savigno"
    }],
    "d5fd2fb1": [{
      "hkey": "d89ee083",
      "slug": "calcara",
      "name": "Calcara",
      "primary": true,
      "skipSearch": false
    }],
    "calcara": [{
      "hkey": "d89ee083",
      "slug": "calcara",
      "name": "Calcara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "crespellano"
    }],
    "283a4666": [{
      "hkey": "c11a400d",
      "slug": "castelletto",
      "name": "Castelletto",
      "primary": true,
      "skipSearch": false
    }],
    "castelletto": [{
      "hkey": "c11a400d",
      "slug": "castelletto",
      "name": "Castelletto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "bc4c3a71": [{
      "hkey": "73c025d1",
      "slug": "fagnano-zappolino",
      "name": "Fagnano-Zappolino",
      "primary": true,
      "skipSearch": false
    }],
    "fagnano": [{
      "hkey": "73c025d1",
      "slug": "fagnano-zappolino",
      "name": "Fagnano-Zappolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "6f758201": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "maiola": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24e89595": [{
      "hkey": "59f64109",
      "slug": "mercatello",
      "name": "Mercatello",
      "primary": true,
      "skipSearch": false
    }],
    "mercatello": [{
      "hkey": "59f64109",
      "slug": "mercatello",
      "name": "Mercatello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "merlano": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e17a7f06": [{
      "hkey": "a7b71e27",
      "slug": "montebudello",
      "name": "Montebudello",
      "primary": true,
      "skipSearch": false
    }],
    "montebudello": [{
      "hkey": "a7b71e27",
      "slug": "montebudello",
      "name": "Montebudello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "monteveglio"
    }],
    "022abb7b": [{
      "hkey": "f5c85367",
      "slug": "muffa",
      "name": "Muffa",
      "primary": true,
      "skipSearch": false
    }],
    "muffa": [{
      "hkey": "f5c85367",
      "slug": "muffa",
      "name": "Muffa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "crespellano"
    }],
    "bf224f22": [{
      "hkey": "f1193e18",
      "slug": "ponte-samoggia",
      "name": "Ponte Samoggia",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-samoggia": [{
      "hkey": "f1193e18",
      "slug": "ponte-samoggia",
      "name": "Ponte Samoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "crespellano"
    }],
    "036f5fbe": [{
      "hkey": "cfe98f75",
      "slug": "ponzano",
      "name": "Ponzano",
      "primary": true,
      "skipSearch": false
    }],
    "ponzano": [{
      "hkey": "cfe98f75",
      "slug": "ponzano",
      "name": "Ponzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "afa8f974": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "pragatto": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c08b9a76": [{
      "hkey": "b39ad758",
      "slug": "rodiano",
      "name": "Rodiano",
      "primary": true,
      "skipSearch": false
    }],
    "rodiano": [{
      "hkey": "b39ad758",
      "slug": "rodiano",
      "name": "Rodiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "savigno"
    }],
    "f556c01e": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "samoggia": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bba7ef7e": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "san-biagio": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d04be986": [{
      "hkey": "0b5bbacd",
      "slug": "san-prospero",
      "name": "San Prospero",
      "primary": true,
      "skipSearch": false
    }],
    "san-prospero": [{
      "hkey": "0b5bbacd",
      "slug": "san-prospero",
      "name": "San Prospero",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "savigno"
    }],
    "dc0e8c88": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cbf31052": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "serravalle": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b08bd15": [{
      "hkey": "10fb6c0a",
      "slug": "stiore-oliveto",
      "name": "Stiore-Oliveto",
      "primary": true,
      "skipSearch": false
    }],
    "stiore-oliveto": [{
      "hkey": "10fb6c0a",
      "slug": "stiore-oliveto",
      "name": "Stiore-Oliveto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "monteveglio"
    }],
    "af4069fc": [{
      "hkey": "d38e5a14",
      "slug": "tiola",
      "name": "Tiola",
      "primary": true,
      "skipSearch": false
    }],
    "tiola": [{
      "hkey": "d38e5a14",
      "slug": "tiola",
      "name": "Tiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "93b5a664": [{
      "hkey": "ee36f3e2",
      "slug": "vedegheto",
      "name": "Vedegheto",
      "primary": true,
      "skipSearch": false
    }],
    "vedegheto": [{
      "hkey": "ee36f3e2",
      "slug": "vedegheto",
      "name": "Vedegheto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "savigno"
    }],
    "b40025fe": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "skipSearch": false
    }],
    "vignola-dei-conti": [{
      "hkey": "c8af059b",
      "slug": "valsamoggia",
      "name": "Valsamoggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fddaaa00": [{
      "hkey": "73c025d1",
      "slug": "fagnano-zappolino",
      "name": "Fagnano-Zappolino",
      "primary": true,
      "skipSearch": false
    }],
    "zappolino": [{
      "hkey": "73c025d1",
      "slug": "fagnano-zappolino",
      "name": "Fagnano-Zappolino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "castello-di-serravalle"
    }],
    "e2ec4070": [{
      "hkey": "007a8d99",
      "slug": "ziribega",
      "name": "Ziribega",
      "primary": true,
      "skipSearch": false
    }],
    "ziribega": [{
      "hkey": "007a8d99",
      "slug": "ziribega",
      "name": "Ziribega",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "monteveglio"
    }]
  }
};
exports["default"] = _default;